import React, { useEffect, useContext, useState } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Cookies from 'universal-cookie';
import { getTitle, getDecodedCookie } from '../../helpers/helperApp';
import { Fragment } from 'react';
import GesUplm  from '../../componentes/formulario/GesUplm/GesUplm';
import { Alert } from '../../componentes/ui/Alert';

function GesDoc(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ idTipAdj, saveIdTipAdj ] = useState(null);    

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{   
                    document.title = getTitle(confPantalla.config.trad, confPantalla.gesdoc.title);                                    
                    if( respuesta == 1 ){
                        
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idtip" in props.location.state ){                                   
                                saveIdTipAdj(props.location.state.idtip);                                                          
                            }                        
                        }                                     
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])

    return(
        <div className="App wrapper">        
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        }
        <Alert /> 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            idTipAdj != null
                            ?                                
                                <GesUplm
                                    confPantalla={confPantalla}
                                    idTipAdj={idTipAdj}                                    
                                >
                                </GesUplm>                                
                            :
                                null
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default GesDoc